export * from './getProductConfig';
